var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-sticky',[_c('van-nav-bar',{staticClass:"nav_title",attrs:{"title":_vm.titleName,"left-text":"返回","left-arrow":""},on:{"click-left":_vm.onClickLeft}})],1),_vm._v(" "),_c('div',{staticClass:"cont"},[_c('div',{staticClass:"rich_text",domProps:{"innerHTML":_vm._s(_vm.data)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b08fb5ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/siteDetail.vue
// module id = null
// module chunks = 